import { Images } from '@microfrontends/react-components'
import { OrderManagementIcon } from '@microfrontends/react-components/components/Images'

export const SUCCESS_CODE = 200

export enum ESection {
    SAVED_JOB = 'saved_job'
}

export enum EPage {
    DASHBOARD = 'dashboard',
    MY_PROFILE = 'myProfile',
    PROFILE_SETTING = 'profileSettings',
    MY_COMPANIES = 'myCompanies',
    MY_JOBS = 'myJobs',
    VIEWED_JOBS = 'viewedJobs',
    JOB_ALERTS = 'jobAlerts',
    ACCOUNT_SETTING = 'accountSettings',
    RECOMMENDED_JOBS = 'recommendedJobs',
    APPLIED_JOB = 'appliedJobs',
    ORDER_MANAGEMENT = 'orderMangagement'
}

export const menu = {
    [EPage.DASHBOARD]: {
        name: EPage.DASHBOARD,
        text: 'Dashboard',
        link: '/my-career-center/dashboard',
        redirect: false,
        image: <Images.DashboardIcon />,
        children: {}
    },
    [EPage.MY_PROFILE]: {
        name: EPage.MY_PROFILE,
        text: 'My Profile',
        link: '/my-profile',
        redirect: false,
        image: <Images.MyProfileIcon />,
        children: {}
    },
    [EPage.MY_COMPANIES]: {
        name: EPage.MY_COMPANIES,
        text: 'My Companies',
        link: '/my-career-center/my-companies',
        redirect: false,
        image: <Images.MyCompaniesIcon />,
        children: {}
    },
    [EPage.MY_JOBS]: {
        name: EPage.MY_JOBS,
        text: 'My Jobs',
        link: '/my-career-center/my-jobs',
        redirect: false,
        image: <Images.MyJobsIcon />,
        children: {}
    },
    [EPage.JOB_ALERTS]: {
        name: EPage.JOB_ALERTS,
        text: 'Job Alerts',
        link: '/my-career-center/my-job-alert',
        redirect: false,
        image: <Images.JobAlertsIcon />,
        children: {}
    },
    [EPage.ORDER_MANAGEMENT]: {
        name: EPage.ORDER_MANAGEMENT,
        text: 'Order Management',
        link: '/order-management',
        redirect: false,
        image: <OrderManagementIcon />,
        children: {}
    },
    [EPage.ACCOUNT_SETTING]: {
        name: EPage.ACCOUNT_SETTING,
        text: 'Account Settings',
        link: '/account-settings',
        redirect: false,
        image: <Images.AccountSettingsIcon />,
        children: {}
    }
}

export const ResumeType = {
    AttachCV: 'attach-cv',
    Profile: 'profile'
}
export const SEARCHABLE_ON = 1
export const SEARCHABLE_OFF = 0
export const ALLOW_SEARCHABLE_DISPLAY = 1

export const DEFAULT_ALLOW_EXT = ['.doc', '.docx', '.pdf']
